import styled from "styled-components";

import Epost from ".././components/Epost";

import Strato from "./../images/artister/2025/lasse-strato.jpg";


const ExtraImage = styled.img`
  width: 180px;
  float: left;
  margin: 2px 1rem 0.3rem 0;
`;




const artistInfo = [
  /* 
    {
      id: 1,
      namn: function () {
        return <>SÄSONGSÖPPNING</>;
      },
      namn_en: function () {
        return <>SEASON OPENING</>;
      },
      namn_de: function () {
        return <>SAISONSERÖFFNUNG</>;
      },
      info: function () {
        return (
          <>
            <p>
              Påskafton kl. 11 öppnar krogen dörrarna för säsongen!<br />
              Sedan kommer vi ha öppet lördagar, söndagar och helgdagar kl. 11 - 15.
              <br />Fr.o.m. skolavslutningen 11 juni har vi öppet dagligen; vardagar 11 - 17 och helger 11 - 16.
            </p>
            <p>
              Varmt välkomna till påsk!
            </p>
          </>
        );
      },
      info_en: function () {
        return (
          <>
            <p>
              On Easter Eve at 11 AM, the restaurant opens its doors for the season!<br />
              After that, we will be open Saturdays, Sundays and public holidays from 11 AM to 3 PM.
              <br />From the end of the school year on June 11, we are open daily; weekdays 11 AM - 5 PM and weekends 11 AM - 4 PM.
            </p>
            <p>
              A warm welcome for Easter!
            </p>
          </>
        );
      },
      info_de: function () {
        return (
          <>
            <p>
              Am Ostersamstag um 11 Uhr öffnet das Restaurant seine Türen für die Saison!<br />
              Danach haben wir samstags, sonntags und an Feiertagen von 11 bis 15 Uhr geöffnet.
              <br />Ab dem Schuljahresende am 11. Juni haben wir täglich geöffnet; werktags 11 - 17 Uhr und an Wochenenden 11 - 16 Uhr.
            </p>
            <p>
              Herzlich willkommen zu Ostern!
            </p>
          </>
        );
      },
      datum: "2026-04-04",
      img: "säsongsöppning",
      pris: 1,
      tid: "11:00",
      konsertmeny: false,
      music: false,
      konst: false,
      author: false,
    },
  */
  {
    id: 2,
    namn: function () {
      return <>MIDSOMMARAFTON</>;
    },
    namn_en: function () {
      return <>MIDSUMMER EVE</>;
    },
    namn_de: function () {
      return <>MITTSOMMERABEND</>;
    },
    info: function () {
      return (
        <>
          <p>
            Traditionsenligt så firar vi midsommar på Oxelö Krog med dans och lekar kring midsommarstången till levande musik!<br />

            Midsommarstången kommer att kläs och resas mellan kl 10 - 12.<br />
            Kl. 13 blir det musik och ringlekar!<br />

            <p>Caféet är öppet 10 till 16.
            </p>

            Denna dag har vi en begränsad, speciell midsommarmeny.

            <ul>
              <li>Midsommartallrik 245 kr - 3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, potatis, smör och bröd.</li>
              {/* 
              <li> Varmrökt lax med färsk potatis och romröra samt smör och bröd</li>
              */}
              <li>Räksmörgås - 159 kr</li>
              <li> Pannkakor med grädde och sylt 70/90 kr</li>
            </ul>

            <p>Dessutom har vi förstås fika med vår fina midsommartårta med jordgubbar</p>


            Varmt välkomna! < br /> <br />
            Glöm inte att ta med folkdräkt om du har en!
          </p >
          <p>OBS! På midsommarafton kommer det inte vara möjligt att parkera på Kroggränd eftersom vi kommer ha dansen där. Vi hänvisar istället till stora parkeringen.</p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            As is tradition, we celebrate Midsummer at Oxelö Krog with dancing and games around the maypole to live music!<br />

            The maypole will be decorated and raised between 10 AM and 12 PM.<br />
            At 1 PM there will be music and ring dances!<br />

            <p>The café is open from 10 AM to 4 PM.
            </p>

            On this day we have a limited, special Midsummer menu.

            <ul>
              <li>Midsommartallrik 220 kr - 3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, potatis, smör och bröd.</li>
              <li>Räksmörgås</li>
              <li> Pannkakor med grädde och sylt</li>
            </ul>

            <p>We also have fika including our lovely Midsummer cake with strawberries</p>


            A warm welcome! < br /> <br />
            Don't forget to bring your folk costume if you have one!
          </p >
          <p>NOTE! On Midsummer Eve it will not be possible to park on Kroggränd as we will have the dancing there. Please use the main parking area instead.</p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Traditionsgemäß feiern wir Mittsommer im Oxelö Krog mit Tanz und Spielen rund um die Mittsommerstange zu Live-Musik!<br />

            Die Mittsommerstange wird zwischen 10 und 12 Uhr geschmückt und aufgestellt.<br />
            Um 13 Uhr gibt es Musik und Ringtänze!<br />

            <p>Das Café ist von 10 bis 16 Uhr geöffnet.
            </p>

            An diesem Tag haben wir ein begrenztes, spezielles Mittsommermenü.

            <ul>
              <li>Midsommartallrik 220 kr - 3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, potatis, smör och bröd.</li>
              <li>Räksmörgås</li>
              <li> Pannkakor med grädde och sylt</li>
            </ul>

            <p>Außerdem gibt es natürlich Kaffee und Kuchen, darunter unsere schöne Mittsommertorte mit Erdbeeren</p>


            Herzlich willkommen! < br /> <br />
            Vergessen Sie nicht, Ihre Tracht mitzubringen, falls Sie eine haben!
          </p >
          <p>ACHTUNG! Am Mittsommerabend kann auf dem Kroggränd nicht geparkt werden, da dort getanzt wird. Bitte nutzen Sie stattdessen den großen Parkplatz.</p>
        </>
      );
    },
    datum: "2026-06-19",
    img: "midsommar",
    pris: 0,
    tid: "",
    konsertmeny: false,
    music: true,
  },

  {
    id: 3,
    namn: function () {
      return <>Eric Bibb</>;
    },
    namn_en: function () {
      return <>Eric Bibb</>;
    },
    namn_de: function () {
      return <>Eric Bibb</>;
    },
    info: function () {
      return (
        <>
          <p>
            Eric Bibb, född och uppvuxen i New York, är med sina över fyrtio album och mer än femtio år på scenen, en av den internationella bluesvärldens största namn idag och hyllningarna som en av världens främsta akustiska bluesgitarrister är ständigt återkommande.
          </p><p>
            Han har turnerat världen runt i snart trettio år, blivit Grammy-nominerad i USA tre gånger och fått mängder av andra internationella utmärkelser, som t. ex pris för årets akustiska bluesalbum från The Blues Foundation i Memphis 2017 & 2022 och "Blues Act Of The Year" vid Jazz FM Awards i London 2019. 2022 fick Eric även Stockholms Stads hederspris i musik.
          </p><p>
            Eric har samarbetat med storheter som t.ex Mavis & Pops Staples, Taj Mahal, Odetta, Bonnie Raitt, The Blind Boys of Alabama och The Dixie Hummingbirds. 2019 spelade han för utsålda hus i en vecka på legendariska Ronnie Scott's i London, då även Van Morrison var Eric's gäst en av kvällarna.
          </p><p>
            2017 turnerade han Sverige runt med den hyllade enmans-föreställningen "Tales From A Blues Brother", som också sändes i Sveriges Television. Den producerades av hans son Rennie Mirro och Filip Adamo och kan nu ses på Qwest TV. Ni har också kunnat se honom i På Spåret, SVT och Bingolotto, TV4, där han sjöng en duett med Sarah Dawn Finer. Sommaren 2022 såg ni honom i SVT:s Allsång På Skansen!
          </p><p>
            I fjol kunde du se honom på Scalateaterns scen Stockholm tillsammans med ett spännande band och gästerna Sarah Dawn Finer och Rennie Mirro. Konserten spelades in och filmades inför ett live-album, som släpptes i april 2024. Hösten 2023 medverkade han i föreställningen 'Ögonblicket' på Västmanlands Teater och är just nu aktuell i rollen som den demente musikern John i filmen 'Så Länge Hjärtat Slår', som kan ses på TV4 Play. Under våren har Eric Bibb turnerat i UK, Irland och Australien för att promota det nya albumet "One Mississippi".
          </p>
          <p>
            Erics far, artisten Leon Bibb, kämpade jämsides med Martin Luther King, Harry Belafonte, Joan Baez och många fler för svartas rättigheter i USA på sextiotalet. Leons framtidsvisioner och mål-medvetenhet tog sig uttryck i musiken och formade Erics konstnärsskap från tidig ålder. Hemma hos familjen Bibb rörde sig en konstant ström av erkända musiker och artister som John Lewis (Erics morbror - pianist/kompositör, grundare av Modern Jazz Quartet), Paul Robeson, Pete Seeger och Josh White. Eric minns särskilt tydligt hur han vid elva års ålder står i pyjamas i vardagsrummet och berättar för Bob Dylan att han minsann också spelar gitarr…
          </p>
          <p>
            Till Oxelö Krog kommer Eric tillsammans med Greger "Knock-Out Greg" Andersson på munspel samt Ulrika Bibb på sång.
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            Eric Bibb, born and raised in New York, with over forty albums and more than fifty years on stage, is one of the biggest names in the international blues world today, and the acclaim for being one of the world's foremost acoustic blues guitarists is ever-recurring.
          </p><p>
            He has toured the world for nearly thirty years, been Grammy-nominated in the USA three times, and received numerous other international awards, such as the award for Best Acoustic Blues Album from The Blues Foundation in Memphis in 2017 & 2022 and "Blues Act Of The Year" at the Jazz FM Awards in London 2019. In 2022, Eric also received the City of Stockholm Honorary Award in Music.
          </p><p>
            Eric has collaborated with greats such as Mavis & Pops Staples, Taj Mahal, Odetta, Bonnie Raitt, The Blind Boys of Alabama and The Dixie Hummingbirds. In 2019, he played to sold-out houses for a week at the legendary Ronnie Scott's in London, where Van Morrison was also Eric's guest one of the evenings.
          </p><p>
            In 2017, he toured across Sweden with the acclaimed one-man show "Tales From A Blues Brother", which was also broadcast on Swedish Television. It was produced by his son Rennie Mirro and Filip Adamo and can now be seen on Qwest TV. You may also have seen him on På Spåret (SVT) and Bingolotto (TV4), where he sang a duet with Sarah Dawn Finer. In the summer of 2022, he appeared on SVT's Allsång På Skansen!
          </p><p>
            Last year you could see him on the Scala Theatre stage in Stockholm together with an exciting band and guests Sarah Dawn Finer and Rennie Mirro. The concert was recorded and filmed for a live album, which was released in April 2024. In the autumn of 2023, he appeared in the production 'Ögonblicket' at Västmanlands Teater and is currently starring as the dementia-afflicted musician John in the film 'Så Länge Hjärtat Slår', which can be seen on TV4 Play. This spring, Eric Bibb has toured the UK, Ireland and Australia to promote the new album "One Mississippi".
          </p>
          <p>
            Eric's father, the artist Leon Bibb, fought alongside Martin Luther King, Harry Belafonte, Joan Baez and many more for Black civil rights in America in the 1960s. Leon's vision for the future and determination found expression in music and shaped Eric's artistry from an early age. The Bibb household saw a constant stream of acclaimed musicians and artists such as John Lewis (Eric's uncle - pianist/composer, founder of the Modern Jazz Quartet), Paul Robeson, Pete Seeger and Josh White. Eric particularly vividly remembers standing in his pyjamas in the living room at the age of eleven, telling Bob Dylan that he too plays guitar...
          </p>
          <p>
            Eric comes to Oxelö Krog together with Greger "Knock-Out Greg" Andersson on harmonica and Ulrika Bibb on vocals.
          </p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Eric Bibb, geboren und aufgewachsen in New York, ist mit über vierzig Alben und mehr als fünfzig Jahren auf der Bühne einer der größten Namen der internationalen Blueswelt, und die Anerkennung als einer der weltweit führenden akustischen Bluesgitarristen ist allgegenwärtig.
          </p><p>
            Er hat seit fast dreißig Jahren die Welt bereist, wurde in den USA dreimal für einen Grammy nominiert und hat zahlreiche weitere internationale Auszeichnungen erhalten, wie z.B. den Preis für das beste akustische Bluesalbum von der Blues Foundation in Memphis 2017 & 2022 und „Blues Act Of The Year" bei den Jazz FM Awards in London 2019. 2022 erhielt Eric außerdem den Ehrenpreis der Stadt Stockholm für Musik.
          </p><p>
            Eric hat mit Größen wie Mavis & Pops Staples, Taj Mahal, Odetta, Bonnie Raitt, The Blind Boys of Alabama und The Dixie Hummingbirds zusammengearbeitet. 2019 spielte er eine Woche lang vor ausverkauftem Haus im legendären Ronnie Scott's in London, wo auch Van Morrison an einem der Abende Erics Gast war.
          </p><p>
            2017 tourte er mit der gefeierten Einmann-Show „Tales From A Blues Brother" durch Schweden, die auch im schwedischen Fernsehen ausgestrahlt wurde. Sie wurde von seinem Sohn Rennie Mirro und Filip Adamo produziert und ist jetzt auf Qwest TV zu sehen. Man konnte ihn auch in På Spåret (SVT) und Bingolotto (TV4) sehen, wo er ein Duett mit Sarah Dawn Finer sang. Im Sommer 2022 war er bei SVTs Allsång På Skansen zu sehen!
          </p><p>
            Letztes Jahr konnte man ihn auf der Bühne des Scala-Theaters in Stockholm zusammen mit einer spannenden Band und den Gästen Sarah Dawn Finer und Rennie Mirro erleben. Das Konzert wurde für ein Live-Album aufgenommen und gefilmt, das im April 2024 veröffentlicht wurde. Im Herbst 2023 wirkte er in der Aufführung „Ögonblicket" am Västmanlands Teater mit und ist derzeit in der Rolle des demenzkranken Musikers John im Film „Så Länge Hjärtat Slår" zu sehen, der auf TV4 Play verfügbar ist. In diesem Frühjahr tourte Eric Bibb durch Großbritannien, Irland und Australien, um das neue Album „One Mississippi" zu bewerben.
          </p>
          <p>
            Erics Vater, der Künstler Leon Bibb, kämpfte in den 1960er Jahren an der Seite von Martin Luther King, Harry Belafonte, Joan Baez und vielen anderen für die Bürgerrechte der Schwarzen in Amerika. Leons Zukunftsvisionen und Zielstrebigkeit fanden ihren Ausdruck in der Musik und prägten Erics Künstlertum von früher Kindheit an. Im Hause Bibb gab es einen ständigen Strom anerkannter Musiker und Künstler wie John Lewis (Erics Onkel - Pianist/Komponist, Gründer des Modern Jazz Quartet), Paul Robeson, Pete Seeger und Josh White. Eric erinnert sich besonders lebhaft daran, wie er als Elfjähriger im Schlafanzug im Wohnzimmer stand und Bob Dylan erzählte, dass er ebenfalls Gitarre spielt...
          </p>
          <p>
            Eric kommt zusammen mit Greger „Knock-Out Greg" Andersson an der Mundharmonika und Ulrika Bibb am Gesang zum Oxelö Krog.
          </p>
        </>
      );
    },
    datum: "2026-06-27",
    img: "eric_1000",
    pris: 280,
    tid: "18:00",
    konsertmeny: true,
    music: true,
    foto: "Jan Malmström",
    slutsålt: true,
    youtube: "https://youtu.be/HYhwUgl3P0U?si=Rcf3quZItAXlTj_i",
    youtubenamn: "Family",
    youtube2: "https://youtu.be/j__moFFnAJg?si=ek6RKqQSL1YU0HyU",
    youtubenamn2: "500 miles",
    biljett_id: 80288,
  },

  {
    id: 4,
    namn: function () {
      return <>Malena Ernman och Mats Bergström</>;
    },
    namn_en: function () {
      return <>Malena Ernman and Mats Bergström</>;
    },
    namn_de: function () {
      return <>Malena Ernman und Mats Bergström</>;
    },
    info: function () {
      return (
        <>
          <p>
            Malena Ernman bjuder tillsammans med gitarristen Mats Bergström på efterlängtade musikpärlor med allt från Mozart till visor jazz och musikal.
          </p><p>
            Malena Ernman är en av Sveriges mest mångsidiga och folkkära artister – en prisbelönt operasångerska med en röst som trollbinder oavsett genre. Hon har erövrat Europas största scener, tävlat i Eurovision och berört publik med både klassisk elegans för sin unika röst, sin sceniska närvaro och sin genreöverskridande musikalitet.
          </p><p>
            Mats Bergström är en av Sveriges främsta gitarrister, med en imponerande bredd inom klassisk musik, jazz, visa och samtida konstmusik. Han är en mångsidig musiker och eftertraktad ackompanjatör som har arbetat med några av landets största artister och tonsättare. Med sin känslighet, precision och kreativa uttryck är han en musikalisk berättare av högsta rang.
          </p><p>
            Tillsammans bildar Malena Ernman och Mats Bergström en enastående duo. Deras samspel präglas av närhet, lyhördhet och en kärlek till musiken som smittar av sig på publiken. I deras gemensamma konserter möts sång och gitarr i ett uttrycksfullt och intimt musikaliskt samtal, där gränser suddas ut mellan genrer, epoker och språk.
          </p>
        </>
      )
    },
    info_en: function () {
      return (
        <>
          <p>
            Malena Ernman, together with guitarist Mats Bergström, presents long-awaited musical gems ranging from Mozart to folk songs, jazz and musical theatre.
          </p><p>
            Malena Ernman is one of Sweden's most versatile and beloved artists -- an award-winning opera singer with a voice that captivates regardless of genre. She has conquered Europe's greatest stages, competed in Eurovision and moved audiences with her classical elegance, unique voice, stage presence and genre-crossing musicality.
          </p><p>
            Mats Bergström is one of Sweden's foremost guitarists, with an impressive range spanning classical music, jazz, folk songs and contemporary art music. He is a versatile musician and sought-after accompanist who has worked with some of the country's greatest artists and composers. With his sensitivity, precision and creative expression, he is a musical storyteller of the highest order.
          </p><p>
            Together, Malena Ernman and Mats Bergström form an outstanding duo. Their interplay is characterised by closeness, sensitivity and a love of music that is infectious to the audience. In their joint concerts, voice and guitar meet in an expressive and intimate musical conversation, where boundaries between genres, eras and languages are blurred.
          </p>
        </>
      )
    },
    info_de: function () {
      return (
        <>
          <p>
            Malena Ernman präsentiert zusammen mit dem Gitarristen Mats Bergström lang ersehnte musikalische Perlen von Mozart über Volkslieder und Jazz bis hin zum Musical.
          </p><p>
            Malena Ernman ist eine der vielseitigsten und beliebtesten Künstlerinnen Schwedens -- eine preisgekrönte Opernsängerin mit einer Stimme, die unabhängig vom Genre verzaubert. Sie hat Europas größte Bühnen erobert, am Eurovision Song Contest teilgenommen und das Publikum mit klassischer Eleganz, ihrer einzigartigen Stimme, ihrer Bühnenpräsenz und ihrer genreübergreifenden Musikalität berührt.
          </p><p>
            Mats Bergström ist einer der führenden Gitarristen Schwedens mit einer beeindruckenden Bandbreite in klassischer Musik, Jazz, Volkslied und zeitgenössischer Kunstmusik. Er ist ein vielseitiger Musiker und gefragter Begleiter, der mit einigen der größten Künstler und Komponisten des Landes zusammengearbeitet hat. Mit seiner Sensibilität, Präzision und seinem kreativen Ausdruck ist er ein musikalischer Erzähler höchsten Ranges.
          </p><p>
            Zusammen bilden Malena Ernman und Mats Bergström ein herausragendes Duo. Ihr Zusammenspiel ist geprägt von Nähe, Einfühlungsvermögen und einer Liebe zur Musik, die auf das Publikum übergreift. In ihren gemeinsamen Konzerten treffen Gesang und Gitarre in einem ausdrucksvollen und intimen musikalischen Dialog aufeinander, in dem die Grenzen zwischen Genres, Epochen und Sprachen verschwimmen.
          </p>
        </>
      )
    },
    datum: "2026-07-04",
    img: "malena_mats",
    foto: "",
    pris: 280,
    tid: "18:00",
    konsertmeny: true,
    music: true,
    youtube: "https://www.youtube.com/watch?v=fa8PN-CazkY",
    youtubenamn: "Gabriellas sång",
    youtube2: "https://www.youtube.com/watch?v=oWkSagVP1uQ",
    youtubenamn2: "Youll never walk alone",
    biljett_id: 79785,

  },

  {
    id: 5,
    namn: function () {
      return <>Janne Schaffer</>;
    },
    namn_en: function () {
      return <>Janne Schaffer</>;
    },
    namn_de: function () {
      return <>Janne Schaffer</>;
    },
    info: function () {
      return (
        <>
          <p>
            Janne Schaffer - My Music Story
          </p><p>
            Varmt välkommen på en fantastisk konsert med Janne Schaffer och pianisten och sångaren Jonas Gideon!  Konserten bjuder på en resa som spänner över i stort sett hela den moderna svenska musikhistorien. Det är en hisnande färd från 60-talets popband, via ABBA och Ted Gärdestad till Björn J:son Lindh och Electric Banana Band med extra fokus på Ted Gärdestad.
          </p><p>
            Janne Schaffer har varit en del av den svenska musikscenen i över 50 år. Han har medverkat på närmare 5000 låtar, gett ut 27 egna skivor samt gjort tio album med Electric Banana Band. Han har spelat med ABBA, Ted Gärdestad, Bob Marley och Toto, gett ut fjorton soloalbum, blivit samplad av Christina Aguilera och nådde förra året topp­placeringar på brittiska klubblistan tillsammans med elektroduon ManyFew. Just nu är han aktuell med filmmusiken till långfilmen Biodlaren med Adam Lundgren, som får biopremiär i år. Hans låt Happy Feet är också med i Jonatan Etzlers biofilm Bad Apples med Saoirse Ronan, som hade världspremiär på Toronto Film Festival.
          </p><p>
            - Jag är så tacksam att jag fortfarande kan vara aktiv både som solist, låtskrivare och studiomusiker och jag lovar att bjuda på massor av musik tillsammans med både fina och roliga minnen, säger Janne Schaffer.
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            Janne Schaffer - My Music Story
          </p><p>
            A warm welcome to an amazing concert with Janne Schaffer and pianist and singer Jonas Gideon! The concert offers a journey spanning virtually the entire modern Swedish music history. It is a breathtaking ride from the pop bands of the 60s, via ABBA and Ted Gärdestad to Björn J:son Lindh and Electric Banana Band, with extra focus on Ted Gärdestad.
          </p><p>
            Janne Schaffer has been part of the Swedish music scene for over 50 years. He has contributed to nearly 5,000 songs, released 27 albums of his own and made ten albums with Electric Banana Band. He has played with ABBA, Ted Gärdestad, Bob Marley and Toto, released fourteen solo albums, been sampled by Christina Aguilera and last year reached top positions on the British club chart together with the electro duo ManyFew. He is currently working on the film score for the feature film Biodlaren (The Beekeeper) starring Adam Lundgren, which premieres in cinemas this year. His song Happy Feet also features in Jonatan Etzler's film Bad Apples with Saoirse Ronan, which had its world premiere at the Toronto Film Festival.
          </p><p>
            - I am so grateful that I can still be active as a soloist, songwriter and studio musician, and I promise to offer lots of music along with both wonderful and fun memories, says Janne Schaffer.
          </p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Janne Schaffer - My Music Story
          </p><p>
            Herzlich willkommen zu einem fantastischen Konzert mit Janne Schaffer und dem Pianisten und Sänger Jonas Gideon! Das Konzert bietet eine Reise, die praktisch die gesamte moderne schwedische Musikgeschichte umspannt. Es ist eine atemberaubende Fahrt von den Popbands der 60er Jahre über ABBA und Ted Gärdestad bis hin zu Björn J:son Lindh und der Electric Banana Band, mit besonderem Fokus auf Ted Gärdestad.
          </p><p>
            Janne Schaffer ist seit über 50 Jahren Teil der schwedischen Musikszene. Er hat an fast 5.000 Songs mitgewirkt, 27 eigene Alben veröffentlicht und zehn Alben mit der Electric Banana Band aufgenommen. Er hat mit ABBA, Ted Gärdestad, Bob Marley und Toto gespielt, vierzehn Soloalben veröffentlicht, wurde von Christina Aguilera gesampelt und erreichte letztes Jahr zusammen mit dem Elektro-Duo ManyFew Spitzenplatzierungen in den britischen Clubcharts. Derzeit arbeitet er an der Filmmusik für den Spielfilm Biodlaren (Der Imker) mit Adam Lundgren, der dieses Jahr Kinopremiere feiert. Sein Song Happy Feet ist auch in Jonatan Etzlers Kinofilm Bad Apples mit Saoirse Ronan zu hören, der seine Weltpremiere beim Toronto Film Festival hatte.
          </p><p>
            - Ich bin so dankbar, dass ich immer noch als Solist, Songwriter und Studiomusiker aktiv sein kann, und ich verspreche, viel Musik zusammen mit schönen und lustigen Erinnerungen zu bieten, sagt Janne Schaffer.
          </p>
        </>
      );
    },
    datum: "2026-07-11",
    img: "schaffer",
    foto: "Annie Hyrefeldt",
    pris: 300,
    tid: "18:00",
    konsertmeny: true,
    slutsålt: false,
    music: true,
    youtube: "https://www.youtube.com/watch?v=QUUGxe-ar9s&t=16s",
    youtubenamn: "Halkans shop live",
    youtube2: "https://www.youtube.com/watch?v=uIvFglCUuuI",
    youtubenamn2: "Brusa högre lilla å",
    biljett_id: 79441,
  },

  {
    id: 6,
    namn: function () {
      return <>Tina Ahlin & Bengan Janson</>;
    },
    namn_en: function () {
      return <>Tina Ahlin & Bengan Janson</>;
    },
    namn_de: function () {
      return <>Tina Ahlin & Bengan Janson</>;
    },
    info: function () {
      return (
        <>
          <p>
            Med budskapet "Keep singing!" ger sig den musikaliska duon Bengan Janson & Tina Ahlin ut på turné med musik och esprit från sina 35 år på scenen!
          </p><p>
            Publiken kommer att få stifta bekantskap med duons musikaliska favoriter från deras samarbeten med Hasse Alfredsson, Tomas von Brömssen, Peter Dalle, Östen med Resten, Ulla Skogh, Robert Broberg med flera. Det blir uppknäppta sånger, livsbejakande poesi och därtill en och annan snapsvisa, både av den vanliga och mer ovanliga slaget. Gärna med högljudd allsång från publiken och spontana infall från artisterna. En perfekt kalas-konsert!
          </p><p>
            Välkommen att uppleva en uppknäppt afton med två extraordinärt hängivna och bedårande musikanter som båda har erhållit simborgarmärket och hel del andra utmärkelser!
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            With the message "Keep singing!", the musical duo Bengan Janson & Tina Ahlin set out on tour with music and esprit from their 35 years on stage!
          </p><p>
            The audience will get to know the duo's musical favourites from their collaborations with Hasse Alfredsson, Tomas von Brömssen, Peter Dalle, Östen med Resten, Ulla Skogh, Robert Broberg and others. There will be light-hearted songs, life-affirming poetry and the occasional drinking song, both of the traditional and more unusual kind. Preferably with loud sing-alongs from the audience and spontaneous improvisations from the artists. A perfect party concert!
          </p><p>
            Welcome to experience an uninhibited evening with two extraordinarily dedicated and charming musicians who have both earned their swimming badges and quite a few other awards!
          </p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Mit der Botschaft „Keep singing!" geht das musikalische Duo Bengan Janson & Tina Ahlin mit Musik und Esprit aus 35 Jahren auf der Bühne auf Tournee!
          </p><p>
            Das Publikum wird die musikalischen Favoriten des Duos aus ihren Zusammenarbeiten mit Hasse Alfredsson, Tomas von Brömssen, Peter Dalle, Östen med Resten, Ulla Skogh, Robert Broberg und anderen kennenlernen. Es gibt unbeschwerte Lieder, lebensbejahende Poesie und dazu das eine oder andere Trinklied, sowohl der gewöhnlichen als auch der ungewöhnlicheren Art. Gerne mit lautem Mitsingen des Publikums und spontanen Einfällen der Künstler. Ein perfektes Fest-Konzert!
          </p><p>
            Willkommen zu einem ausgelassenen Abend mit zwei außerordentlich engagierten und bezaubernden Musikanten, die beide ihr Schwimmabzeichen und eine ganze Reihe weiterer Auszeichnungen erhalten haben!
          </p>
        </>
      );
    },
    datum: "2026-08-01",
    img: "tina_bengan",
    foto: "",
    pris: 250,
    tid: "18:00",
    slutsålt: true,
    konsertmeny: true,
    music: true,
    youtube: "https://www.youtube.com/watch?v=xFojrz43sTA",
    youtubenamn: "Bedårande sommarvals",
    youtube2: "",
    youtubenamn2: "",
    biljett_id: 79784,
  },

  {
    id: 7,
    namn: function () {
      return <>Åsa Jinder</>;
    },
    namn_en: function () {
      return <>Åsa Jinder</>;
    },
    namn_de: function () {
      return <>Åsa Jinder</>;
    },
    info: function () {
      return (
        <>
          <p><b>Åsa Jinder – 50 år som artist</b></p>
          <p>Fira en enastående livsgärning med Åsa Jinder – en av Sveriges mest hyllade och mångsidiga musiker – när hon firar 50 år som artist med en efterlängtad Sverigeturné!
          </p><p>
            Åsa Jinder är inte bara en artist – hon är ett stycke svensk musikhistoria. Redan som 15-åring blev hon Sveriges yngsta riksspelman någonsin, och året därpå debuterade hon med sitt första album. Sedan dess har hon trollbundit publik i över fem decennier med sin nyckelharpa, sin röst och sin starka scenpersonlighet. Hon har fått högsta betyg av kritiker, spelat solo på Nobelfesten och stått på internationella scener – bland annat som en del av gruppen "Secret Garden" med vinnarlåten “Nocturne” i Eurovision Song Contest. I Sverige har hon som enda artist haft audiens hos den japanske kejsaren. Hennes musik har nått enorm framgång med guld- och platinaskivor, sången “Av längtan till dig” är en av Sveriges mest älskade bröllopssånger.
          </p><p>
            Men hennes konstnärskap stannar inte där – hon debuterade som lyriker på Albert Bonniers förlag 1990 och har därefter skrivit två romaner. Hon skrev samtliga sångtexter i kritikerhyllade musikalen "Vänd om min längtan" och stått för manus, regi i den egna produktionen "Det hände i Hårga" en musikal byggd på hennes egna sånger. Som tidigare ledamot i Statens kulturråd har hon dessutom varit med och format Sveriges kulturliv.
          </p><p>
            Det här är mer än en konsert – det är en spegling till en unik karriär, ett musikaliskt arv och en artist som berört generationer. Upplev när tradition möter nutid, i en miljö som förstärker varje ton.
          </p><p>
            Till krogbacken kommer Åsa tillsammans med pianisten Peter Nilsbo.
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p><b>Åsa Jinder – 50 years as an artist</b></p>
          <p>Celebrate a remarkable life's work with Åsa Jinder – one of Sweden's most acclaimed and versatile musicians – as she celebrates 50 years as an artist with a long-awaited Swedish tour!
          </p><p>
            Åsa Jinder isn't just an artist – she is a piece of Swedish music history. At just 15 years old she became Sweden's youngest ever "riksspelman" (master folk musician), and the following year released her debut album. Since then she has enchanted audiences for over five decades with her nyckelharpa, her voice and her powerful stage presence. She has received top marks from critics, performed solo at the Nobel banquet and appeared on international stages – including as part of the group "Secret Garden" with the winning song "Nocturne" in the Eurovision Song Contest. In Sweden she is the only artist to have had an audience with the Japanese emperor. Her music has reached enormous success with gold and platinum records, and the song "Av längtan till dig" is one of Sweden's most beloved wedding songs.
          </p><p>
            But her artistry does not stop there – she debuted as a lyricist with Albert Bonniers förlag in 1990 and has since written two novels. She wrote all the lyrics for the critically acclaimed musical "Vänd om min längtan" and was responsible for script and direction in her own production "Det hände i Hårga", a musical built on her own songs. As a former member of the Swedish Arts Council, she has also helped shape Sweden's cultural life.
          </p><p>
            This is more than a concert – it is a reflection of a unique career, a musical legacy and an artist who has touched generations. Experience tradition meeting the present, in a setting that amplifies every note.
          </p><p>
            Åsa will be joined on the restaurant hillside by pianist Peter Nilsbo.
          </p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p><b>Åsa Jinder – 50 Jahre als Künstlerin</b></p>
          <p>Feiern Sie ein außergewöhnliches Lebenswerk mit Åsa Jinder – einer der gefeiertsten und vielseitigsten Musikerinnen Schwedens – wenn sie ihr 50-jähriges Künstlerjubiläum mit einer langersehnten Schweden-Tournee feiert!
          </p><p>
            Åsa Jinder ist nicht nur eine Künstlerin – sie ist ein Stück schwedischer Musikgeschichte. Bereits mit 15 Jahren wurde sie Schwedens jüngste „Riksspelman" (Meister-Volksmusikerin) aller Zeiten, und im darauffolgenden Jahr veröffentlichte sie ihr erstes Album. Seitdem hat sie das Publikum über fünf Jahrzehnte lang mit ihrer Nyckelharpa, ihrer Stimme und ihrer starken Bühnenpräsenz verzaubert. Sie wurde von Kritikern mit Bestnoten ausgezeichnet, spielte solo beim Nobelbankett und stand auf internationalen Bühnen – unter anderem als Teil der Gruppe „Secret Garden" mit dem Siegertitel „Nocturne" beim Eurovision Song Contest. In Schweden ist sie die einzige Künstlerin, die eine Audienz beim japanischen Kaiser hatte. Ihre Musik hat enormen Erfolg mit Gold- und Platin-Schallplatten erzielt, und das Lied „Av längtan till dig" ist eines der meistgeliebten Hochzeitslieder Schwedens.
          </p><p>
            Aber ihr künstlerisches Schaffen endet hier nicht – sie debütierte 1990 als Lyrikerin beim Verlag Albert Bonnier und hat seitdem zwei Romane geschrieben. Sie schrieb sämtliche Liedtexte für das von der Kritik gefeierte Musical „Vänd om min längtan" und war für Drehbuch und Regie ihrer eigenen Produktion „Det hände i Hårga" verantwortlich, einem Musical, das auf ihren eigenen Liedern basiert. Als ehemaliges Mitglied des schwedischen Kulturrats hat sie zudem das Kulturleben Schwedens mitgestaltet.
          </p><p>
            Das ist mehr als ein Konzert – es ist ein Spiegelbild einer einzigartigen Karriere, eines musikalischen Erbes und einer Künstlerin, die Generationen berührt hat. Erleben Sie, wie Tradition auf Gegenwart trifft, in einer Umgebung, die jeden Ton verstärkt.
          </p><p>
            Auf den Krogbacken kommt Åsa zusammen mit dem Pianisten Peter Nilsbo.
          </p>
        </>
      );
    },
    datum: "2026-07-18",
    img: "Jinder",
    foto: "Anna Alverhag",
    pris: 250,
    tid: "18:00",
    konsertmeny: true,
    music: true,
    youtube: "https://www.youtube.com/watch?v=Bp0uCwgykxY",
    youtubenamn: "Vi har älskat länge nu",
    biljett_id: 81059,
  },

  {
    id: 8,
    namn: function () {
      return <>Calaisa</>;
    },
    namn_en: function () {
      return <>Calaisa</>;
    },
    namn_de: function () {
      return <>Calaisa</>;
    },
    info: function () {
      return (
        <>
          <p>
            Calaisa var i början av 2000-talet pionjärer med sin unika blandning av americana och country. Med influenser från Allison Krauss, The Beatles, Sheryl Crow och Joni Mitchell har de alltid skapat musik som känns både tidlös och samtida. Debutalbumet ”Calaisa” sålde guld, och uppföljaren ”Grafton Street” gav dem en Grammis-nominering 2009. Calaisa består av två syskonpar: Lisa och Caisa Troedsson samt Malin och Anna Törnquist. Bandet slog igenom i Nashville och nominerades till en CMA Award för Best International Country Album. De har turnerat med storheter som Simply Red, LeAnn Rimes och Céline Dion, och hyllats för sin stämsång, melodiska skärpa och äkthet.
          </p><p>
            Men resan från spontana gatumusikframträdanden världen över, där passion och talang tog dem hela vägen till några av världens största scener, tog 2012 en abrupt paus när Calaisa plötsligt försvann från rampljuset i över tio år. Bara bandets medlemmar vet varför, men lyckligtvis blev pausen inte slutet. De blev vuxna kvinnor, bildade familjer och skapade nya liv, men längtan tillbaka till musiken och vänskapen var för stark. Nu står de här igen, med mer liv att skriva om och en återfunnen kärlek till bandet och varandra. Det här är början på nästa kapitel.
          </p><p>
            Bandets kommande album är producerat av Calaisa tillsammans med Tobias Fröberg, känd för sitt arbete med Alba August, Ane Brun och Frida Hyvönen. Albumet släpps våren 2026. Då åker äntligen Calaisa återigen ut på livescener runt om i Sverige för att trollbinda publiken med energi, samspel och magiska harmonier.
          </p><p>
            Lineup:<br />
            Anna Törnquist Berggrensson, sång, fiol, slagverk, piano<br />
            Lisa Troedsson Rasmusson, sång, gitarr, mandolin<br />
            Malin Törnquist, sång, gitarr<br />
            Caisa Troedsson, sång, bas<br />
            En femte musiker kommer att medverka. Vem det blir meddelas senare.
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            In the early 2000s, Calaisa were pioneers with their unique blend of americana and country. With influences from Alison Krauss, The Beatles, Sheryl Crow and Joni Mitchell, they have always created music that feels both timeless and contemporary. The debut album "Calaisa" went gold, and the follow-up "Grafton Street" earned them a Grammis nomination in 2009. Calaisa consists of two pairs of sisters: Lisa and Caisa Troedsson together with Malin and Anna Törnquist. The band broke through in Nashville and was nominated for a CMA Award for Best International Country Album. They have toured with greats such as Simply Red, LeAnn Rimes and Céline Dion, and been praised for their vocal harmonies, melodic sharpness and authenticity.
          </p><p>
            But the journey from spontaneous street performances around the world, where passion and talent took them all the way to some of the world's biggest stages, took an abrupt pause in 2012 when Calaisa suddenly disappeared from the spotlight for over ten years. Only the band members know why, but luckily the break was not the end. They became grown women, started families and created new lives, but the longing back to the music and the friendship was too strong. Now here they are again, with more life to write about and a rediscovered love for the band and each other. This is the beginning of the next chapter.
          </p><p>
            The band's upcoming album is produced by Calaisa together with Tobias Fröberg, known for his work with Alba August, Ane Brun and Frida Hyvönen. The album is released in spring 2026. Then Calaisa finally heads out again to live stages around Sweden to enchant audiences with energy, interplay and magical harmonies.
          </p><p>
            Lineup:<br />
            Anna Törnquist Berggrensson – vocals, fiddle, percussion, piano<br />
            Lisa Troedsson Rasmusson – vocals, guitar, mandolin<br />
            Malin Törnquist – vocals, guitar<br />
            Caisa Troedsson – vocals, bass<br />
            A fifth musician will join them. Who that will be is to be announced later.
          </p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            In den frühen 2000er Jahren waren Calaisa Pioniere mit ihrer einzigartigen Mischung aus Americana und Country. Mit Einflüssen von Alison Krauss, The Beatles, Sheryl Crow und Joni Mitchell haben sie stets Musik geschaffen, die sich sowohl zeitlos als auch zeitgenössisch anfühlt. Das Debütalbum „Calaisa" wurde mit Gold ausgezeichnet, und der Nachfolger „Grafton Street" brachte ihnen 2009 eine Grammis-Nominierung ein. Calaisa besteht aus zwei Schwesternpaaren: Lisa und Caisa Troedsson sowie Malin und Anna Törnquist. Die Band feierte ihren Durchbruch in Nashville und wurde für einen CMA Award als „Best International Country Album" nominiert. Sie sind mit Größen wie Simply Red, LeAnn Rimes und Céline Dion getourt und wurden für ihren Gesang, ihre melodische Schärfe und ihre Authentizität gefeiert.
          </p><p>
            Doch die Reise von spontanen Straßenmusik-Auftritten rund um die Welt, bei denen Leidenschaft und Talent sie bis auf einige der größten Bühnen der Welt brachten, nahm 2012 eine abrupte Pause, als Calaisa plötzlich für über zehn Jahre aus dem Rampenlicht verschwand. Nur die Bandmitglieder wissen warum, aber zum Glück war die Pause nicht das Ende. Sie wurden erwachsene Frauen, gründeten Familien und schufen neue Leben, aber die Sehnsucht nach der Musik und der Freundschaft war zu stark. Jetzt stehen sie wieder hier, mit mehr Leben, über das sie schreiben können, und einer wiedergefundenen Liebe zur Band und zueinander. Dies ist der Beginn des nächsten Kapitels.
          </p><p>
            Das kommende Album der Band wird von Calaisa zusammen mit Tobias Fröberg produziert, bekannt für seine Arbeit mit Alba August, Ane Brun und Frida Hyvönen. Das Album erscheint im Frühjahr 2026. Dann gehen Calaisa endlich wieder auf Live-Bühnen in ganz Schweden, um das Publikum mit Energie, Zusammenspiel und magischen Harmonien zu verzaubern.
          </p><p>
            Lineup:<br />
            Anna Törnquist Berggrensson – Gesang, Geige, Percussion, Klavier<br />
            Lisa Troedsson Rasmusson – Gesang, Gitarre, Mandoline<br />
            Malin Törnquist – Gesang, Gitarre<br />
            Caisa Troedsson – Gesang, Bass<br />
            Ein fünfter Musiker wird mitwirken. Wer das sein wird, wird später bekannt gegeben.
          </p>
        </>
      );
    },
    datum: "2026-08-08",
    img: "calaisa",
    foto: "Isabell N Wedin",
    pris: 250,
    tid: "18:00",
    konsertmeny: true,
    music: true,
    youtube: "https://www.youtube.com/watch?v=pNWywkrwRbo",
    youtubenamn: "Sisters in arms",
    youtube2: "https://www.youtube.com/watch?v=b2UpPaqedYo",
    youtubenamn2: "HEY NOW",
    biljett_id: 81340,
  },

  {
    id: 9,
    namn: function () {
      return <>BELLMANDAGEN</>;
    },
    namn_en: function () {
      return <>BELLMAN DAY</>;
    },
    namn_de: function () {
      return <>BELLMAN-TAG</>;
    },
    info: function () {
      return (
        <>
          <p>
            Vår traditionella Bellmandag blir i år på en söndag. Som vanligt
            kommer krogbacken att befolkas av 1700-talsklädda individer och vi
            klär även upp vår personal!
          </p>
          <p>
            Thord Lindé kommer att underhålla såsom Fredman tillsammans med sina musiker samt även gästframträdanden.
          </p>
          <p>
            Bellman-quiz för stora och små utlovas med fina Bellman-priser!
          </p>
          <p>
            De som kommer 1700-talsklädda bjuder vi på något att äta. Så ta fram din gamla 1700-talsdräkt ur garderoben!
          </p>

          {/*
            <p>
              Hålltider:<br />
              <ul>
                <li>kl. 12 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 13 Folk- och vistrion ro.t.</li>
                <li>kl. 14 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 14:40 Vinnarna i årets Quiz koras.</li>
              </ul>
            </p>
          */}

          <p>Varmt välkomna!</p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            Our traditional Bellman Day falls on a Sunday this year. As usual,
            the restaurant grounds will be populated by individuals dressed in
            18th-century attire and we will dress up our staff as well!
          </p>
          <p>
            Thord Lindé will entertain as Fredman together with his musicians, along with guest appearances.
          </p>
          <p>
            A Bellman quiz for young and old is promised, with lovely Bellman prizes!
          </p>
          <p>
            Those who come dressed in 18th-century clothing will be treated to something to eat. So dig out your old 18th-century costume from the wardrobe!
          </p>

          {/*
            <p>
              Hålltider:<br />
              <ul>
                <li>kl. 12 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 13 Folk- och vistrion ro.t.</li>
                <li>kl. 14 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 14:40 Vinnarna i årets Quiz koras.</li>
              </ul>
            </p>
          */}

          <p>A warm welcome!</p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Unser traditioneller Bellman-Tag fällt dieses Jahr auf einen Sonntag.
            Wie gewohnt wird das Gelände des Restaurants von Personen in
            Kleidung des 18. Jahrhunderts bevölkert, und auch unser Personal
            wird entsprechend gekleidet!
          </p>
          <p>
            Thord Lindé wird als Fredman zusammen mit seinen Musikern unterhalten, einschließlich Gastauftritte.
          </p>
          <p>
            Ein Bellman-Quiz für Groß und Klein wird versprochen, mit schönen Bellman-Preisen!
          </p>
          <p>
            Wer in Kleidung des 18. Jahrhunderts kommt, wird von uns mit etwas zu essen bewirtet. Also holen Sie Ihr altes Kostüm aus dem 18. Jahrhundert aus dem Schrank!
          </p>

          {/*
            <p>
              Hålltider:<br />
              <ul>
                <li>kl. 12 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 13 Folk- och vistrion ro.t.</li>
                <li>kl. 14 Thord Lindé med Erik Söderlind och Jan Adefelt</li>
                <li>kl. 14:40 Vinnarna i årets Quiz koras.</li>
              </ul>
            </p>
          */}

          <p>Herzlich willkommen!</p>
        </>
      );
    },
    datum: "2026-07-26",
    img: "bellmandagen",
    pris: 0,
    tid: "HELA DAGEN",
    konsertmeny: false,
    music: true,
    youtube: "https://www.youtube.com/watch?v=t1ggVXHyvNw",
    youtubenamn: "SOLEN GLIMMAR",

  },
  {
    id: 10,
    namn: function () {
      return <>Författartisdag med <nobr>Eric Cullhed</nobr></>;
    },
    namn_en: function () {
      return <>Eric Cullhed</>;
    },
    namn_de: function () {
      return <>Eric Cullhed</>;
    },
    info: function () {
      return (
        <>
          <p>
            Vi har den stora äran att kunna välkomna Eric Cullhed till krogbacken i sommar! Eric Cullhed är professor i grekiska vid Uppsala universitet och skribent i bl.a. Svenska Dagbladet. I sin nya bok "Gråt: tårarnas filosofi - från antiken till idag" undersöker han gråtandets betydelse genom tiderna.
          </p>
          <p>
            Människan är det enda djur som ibland brister ut i tårar och snyftningar. Vad är meningen med detta egendomliga beteende, och hur kan något som ligger oss så nära ändå vara så gåtfullt?
          </p>
          <p>
            Genom historien har filosofer och teologer, biologer, psykologer och konstnärer frågat sig varför vi gråter. Men gång på gång har de talat förbi varandra, försummat sina föregångares insikter och landat i motsägelsefulla svar.
          </p>
          <p>
            I denna bok ger sig Eric Cullhed ut på jakt efter vad gråt egentligen är. I mötet med tänkare och forskare från olika platser och tider utvecklar han en förklaring till varför gråt inte bara är ett svaghetstecken utan ett språk som rymmer både sårbarhet och styrka – smärta, men också lycka och en antydan om livets mening.
          </p>
          <p>
            "Stilen är lärd och kvick, och det är trivsamt att som läsare tas med på denna krokiga kunskapsväg."<br /> Svenska Dagbladet </p>
          <p>
            "En briljant resa mellan antik mytologi och modern vetenskap … Om den här boken inte nomineras till Augustpriset kommer jag att brista ut i gråt."<br /> UNT </p>
          <p>
            Varmt välkomna till en spännande föredrag fyllt av tårar!
          </p>
        </>
      );
    },

    datum: "2026-06-30",
    img: "Eric_Cullhed",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 11,
    namn: function () {
      return <>Författartisdag med <nobr>Lars Lager</nobr></>;
    },
    namn_en: function () {
      return <>Lars Lager</>;
    },
    namn_de: function () {
      return <>Lars Lager</>;
    },
    info: function () {
      return (
        <>
          <p>
            Lars Lager har skrivit sex böcker. Så här säger han själv om sitt författarskap:
          </p>
          <p>
            "De historier jag berättar vill jag ska vara god underhållning, men även ge någonting mer. De böcker jag hittills har skrivit hoppas och tror jag även ger läsaren en möjlighet till reflektion över hur vi människor behandlar varandra och miljön omkring oss.""
          </p>
          <p>
            Lars kommer att berätta om sina böcker men fokusera mest på sin senaste bok som heter Ondskans krigare, och den handlar om en ung, svensk man som frivilligt strider för Hitler under andra världskriget.
          </p>
          <p>
            Det kommer att handla om nazismen och antisemitismen under 30- och 40-talen, den svenska eftergiftspolitiken, vardagslivet med ransoneringar och inkallelser, samt lite om svenskar som på ett eller annat sätt var inblandade som stridande i kriget.
          </p>
          <p>
            Varmt välkomna på ett spännande föredrag!
          </p>

        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            Lars Lager has written six books. This is how he describes his authorship himself:
          </p>
          <p>
            “I want the stories I tell to be good entertainment, but also to offer something more. I hope and believe that the books I have written so far also give the reader an opportunity to reflect on how we humans treat one another and the environment around us.”
          </p>
          <p>
            Lars will talk about his books, but will focus mainly on his latest book, Warriors of Evil, which is about a young Swedish man who voluntarily fights for Hitler during the Second World War.
          </p>
          <p>
            The lecture will cover Nazism and antisemitism during the 1930s and 1940s, Sweden’s policy of appeasement, everyday life with rationing and military call-ups, as well as some information about Swedes who, in one way or another, were involved as combatants in the war.
          </p>
          <p>
            A warm welcome to an exciting lecture!
          </p>

          <p>A warm welcome!</p>
        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Lars Lager hat sechs Bücher geschrieben. So beschreibt er selbst sein schriftstellerisches Schaffen:
            <p>
            </p>
            „Die Geschichten, die ich erzähle, sollen gute Unterhaltung sein, aber auch mehr bieten. Ich hoffe und glaube, dass die Bücher, die ich bisher geschrieben habe, dem Leser auch die Möglichkeit geben, darüber nachzudenken, wie wir Menschen miteinander und mit unserer Umwelt umgehen.“
            <p>
            </p>
            Lars wird über seine Bücher sprechen, sich jedoch hauptsächlich auf sein neuestes Buch Krieger des Bösen konzentrieren. Es handelt von einem jungen schwedischen Mann, der während des Zweiten Weltkriegs freiwillig für Hitler kämpft.
            <p>
            </p>
            Der Vortrag wird sich mit dem Nationalsozialismus und Antisemitismus der 1930er- und 1940er-Jahre, der schwedischen Nachgiebigkeitspolitik, dem Alltag mit Rationierungen und Einberufungen sowie mit einigen Schweden befassen, die auf die eine oder andere Weise als Kämpfende am Krieg beteiligt waren.
            <p>
            </p>
            Herzlich willkommen zu einem spannenden Vortrag!
          </p>
          <p>Herzlich willkommen!</p>
        </>
      );
    },
    datum: "2026-07-07",
    img: "lars_lager_web",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 12,
    namn: function () {
      return <>Fotoutställning <nobr>Per-Ola Björn</nobr></>;
    },
    namn_en: function () {
      return <>Phography Per-Ola Björn</>;
    },
    namn_de: function () {
      return <>Fotos - Per-Ola Björn</>;
    },
    info: function () {
      return (
        <>
          <p>
            Under sommaren visas ett urval av fotografen Per-Ola Björns bilder i en utställning på Oxelö krog. Uställningen visas från den 13 juni och en bit in i augusti. Kom på vernissage lördagen den 13 juni kl. 14 till 15!
          </p>
          <p>
            Per-Ola är född 1955 i norra Uppland och uppväxt i Bro, men från 2023 bor han i Nyköping. Han har länge engagerat sig i naturskydds- och miljöfrågor och har ett stort musikintresse. Fotointresset kom redan i de tidiga tonåren. Per-Ola vill fånga och förmedla skönheten och mångfalden i naturen och vår omgivning och avbildar gärna något som är ”vackert”, intressant och/eller något som väcker känslor.
          </p>
          <p>
            "Det är kul om jag med mina bilder lyckas med att väcka en eftertanke, förmedla ett budskap, väcka ett intresse eller varför inte ett skratt?!" /Per-Ola Björn
          </p>
        </>
      );
    },
    info_en: function () {
      return (
        <>
          <p>
            During the summer, a selection of photographs by photographer Per-Ola Björn will be exhibited at Oxelö Krog. The exhibition opens on June 13 and will run into August. Join us for the opening reception on June 13 from 2:00 PM to 3:00 PM!
          </p>
          <p>
            About Per-Ola Björn
          </p>
          <p>
            Per-Ola was born in 1955 in northern Uppland and grew up in Bro. Since 2023, he has been living in Nyköping. He has long been engaged in nature conservation and environmental issues and has a strong interest in music. His passion for photography began in his early teens.
          </p>
          <p>
            Through his photography, Per-Ola seeks to capture and convey the beauty and diversity of nature and the world around us. He is particularly drawn to subjects that are beautiful, interesting, and/or evoke emotions.
          </p>
          <p>
            “It is rewarding if my photographs can inspire reflection, communicate a message, spark curiosity, or perhaps even bring a smile!”
            — Per-Ola Björn
          </p>

        </>
      );
    },
    info_de: function () {
      return (
        <>
          <p>
            Im Sommer wird eine Auswahl von Fotografien des Fotografen Per-Ola Björn in einer Ausstellung im Oxelö Krog gezeigt. Die Ausstellung ist ab dem 13. Juni zu sehen und läuft bis in den August hinein. Besuchen Sie die Vernissage am 13. Juni von 14:00 bis 15:00 Uhr!
          </p>
          <p>
            Über Per-Ola Björn
          </p>
          <p>
            Per-Ola wurde 1955 im nördlichen Uppland geboren und wuchs in Bro auf. Seit 2023 lebt er in Nyköping. Seit vielen Jahren engagiert er sich für Natur- und Umweltschutz und interessiert sich leidenschaftlich für Musik. Sein Interesse an der Fotografie begann bereits in seiner frühen Jugend.
          </p>
          <p>
            Mit seinen Bildern möchte Per-Ola die Schönheit und Vielfalt der Natur und unserer Umgebung einfangen und vermitteln. Besonders gerne fotografiert er Motive, die schön, interessant und/oder emotional berührend sind.
          </p>
          <p>
            „Es freut mich, wenn es mir mit meinen Bildern gelingt, zum Nachdenken anzuregen, eine Botschaft zu vermitteln, Interesse zu wecken oder vielleicht sogar ein Lächeln hervorzurufen!“
            — Per-Ola Björn
          </p>
        </>
      );
    },
    datum: "2026-06-13",
    img: "bjorn",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: false,
  },
  {
    id: 13,
    namn: function () {
      return <>Författartisdag med <nobr>Anders Omstedt</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            Drömmens dolda intelligens
          </p>
          <p>
            Hur kan drömmar hjälpa oss att förstå både oss själva och världen omkring oss?
          </p>
          <p>
            I denna unika bok visar Anders Omstedt hur våra nattliga drömmar bär på en dold intelligens – ett inre språk som kan öppna dörrar till kreativitet, medkänsla och djupare insikt. Genom exempel från drömarbete i grupp, kombinerat med egna erfarenheter från vetenskap, poesi och filosofi, belyser han drömmens kraft som motvikt till ett alltmer fragmenterat och teknokratiskt samhälle.
          </p>
          <p>
            Vi lever i en tid där den tekniska och ekonomiska utvecklingen hotar att överskugga det mänskliga. Drömmens dolda intelligens är en uppmaning att återknyta kontakten med vårt inre liv – att lyssna till naturens och drömmens röster, för att finna ett mer hållbart och medkännande sätt att vara människa i världen.
          </p>
          <p>
            Anders Omstedt är professor emeritus i oceanografi vid Göteborgs universitet. Parallellt med sin forskning om havets dynamik och utveckling har han fördjupat sig i litteratur, psykologi och drömmar och är verksam som drömgruppsledare inom Drömgruppsforum.
          </p>
        </>
      );
    },
    datum: "2026-07-14",
    img: "omstedt",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 14,
    namn: function () {
      return <>Författartisdag med <nobr>Anci Lampe</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            Anci Lampe är leg. sjuksköterska med specialistutbildning i psykiatri samt författare. Numera är hon bosatt i Oxelösund.
          </p>
          <p>
            Anci Lampe har skrivit en serie av tre självbiografiska romaner; "Det finns gröna hästar", "Inte ens vilda hästar" och "Innanför barken". Undertiteln för alla tre skulle kunna vara: Att tro på ett barns berättelse. eller Vem tar barnets parti?
          </p>
          <p>
            Clara växer upp i en välbärgad familj med högt utbildade föräldrar som har gott anseende och fina vänner. Bakom fasaden pågår hot, våld och hat. Vilket ingen tror på. Inte i en sådan familj!
          </p>
          <p>
            Hon har även skrivit en mysdeckare/pusseldeckare, som utspelar sig i Trosa; "Borta i världens ände" och skriver just nu på uppföljaren.
          </p>
          <p>
            Anci skriver så här om sig själv:
          </p>
          <p>
            Jag har ägnat mig åt skrivande i olika former hela livet, men inte försökt att bli publicerad på allvar förrän på 2020-talet.
            En stor del av min tid har ägnats åt hundar, hästar och musik. Men också till att försöka hjälpa dem jag har haft möjlighet och ork att hjälpa. Jag känner varmt för dem som ses som svaga, och själva verket är det kanske de som är de starkaste.<br />
            Jag var en sådan.
          </p>
          <p>
            Det jag helst vill prata om är om vi tar våra barn på allvar.
          </p>
        </>
      );
    },
    datum: "2026-07-21",
    img: "anci_lampe",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 15,
    namn: function () {
      return <>Berättarsöndag med <nobr>Lasse Lindberg</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            Vi hälsar kultur- och Oxelösundsprofilen och entertainern Lasse Lindberg välkommen till krogbacken för en speciell söndagseftermiddag!
          </p>
          <p>
            <ExtraImage src={Strato} />
            Lasse är född och uppvuxen i Oxelösund. Pappa hade godis och fruktaffär.

            Lasse började medverka i Nyköpings Gästabud 1974 fortsatte medverka i olika roller i hela 25 år!!
          </p>
          <p>
            Lasse skriver visor och texter och han har också författat en mängd kåserier.
          </p>
          <p>
            På krogbacken kommer han att berätta om sitt Oxelösund; minnen och anekdoter ur historien.
          </p>
        </>
      );
    },
    datum: "2026-06-28",
    img: "lasse-lindberg",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 16,
    namn: function () {
      return <>Författartisdag med <nobr>Stefan Antonsson</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            Stefan Antonsson debuterade 2022 med boken En dag på jobbet, som är ett skönlitterärt allvarligt menat inlägg i skoldebatten om våra unga, vilka en dag ska ta över vårt samhälle. Boken är allvarlig, inte sällan gripande, men även rolig.
          </p>
          <p>
            Två år senare kom bok nummer två - Dô-historier. Temat i boken är att vi pratar för mycket och lyssnar för lite. Boken erbjuder läsaren flera tillfällen till goda skratt och igenkännande leenden.
          </p>
          <p>
            Arbetet med en tredje bok pågår. Den är tänkt att bli ett sorts epos utan hjältar o gudar, men väl dåd, som kopplar ihop sig med debutromanen.
          </p>
          <p>
            Frågan som Stefan ställer sig är: "Hur långt är vi beredda att gå i kampen för demokrati, när despotismens piska viner mot oss personligen?"
          </p>
          <p>
            På ett underhållande sätt vill Stefan ge publiken tillbakablickar och erfarenheter från sitt liv, vilka gör att han idag fullt övertygad står för och arbetar utifrån devisen:
            ”Det viktigaste är inte vad du kan, utan vilken människa du blir.”
          </p>
          <p>Varmt välkomna!</p>
        </>
      );
    },
    datum: "2026-07-28",
    img: "antonsson",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 17,
    namn: function () {
      return <>Författartisdag med <nobr>Herman Lindqvist</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            Vi är oerhört glada att det har blivit en tradition att Herman Lindqvist kommer till oss! Vi hälsar honom hjärtligt välkommen tillbaka till Krogbacken!<br /><br />
            Denna gång har han inte avslöjat vad han kommer att berätta om - så det blir spännande. En anonym källa hintar dock om att han nu håller på att skriva en deckare.
          </p>
          <p>Ingen kan som Herman berätta vittert och underhållande direkt ur minnet! Missa inte det!</p>
          <p>
            Herman Lindqvist har skrivit över sextio böcker och han skriver ständigt fler. Det är framför allt historiska verk, men också skönlitteratur, biografier, kåserier m.m.
          </p><p>
            Han föddes i Stockholm 1943, men växte upp i Helsingfors. Han tog studenten, läste statskunskap och började sitt yrkesliv som journalist. Vid 25 års ålder blev han utrikeskorrespondent för Aftonbladet och bevakade sedan under mer än tjugo år krig och katastrofer i alla världsdelar för Aftonbladet, Expressen, SVT och Riksradion. Numera är han bosatt i Warszawa.
          </p><p>
            År 1969 debuterade han med en reportagebok om den ryska invasionen av Tjeckoslovakien. I sin skönlitterära debut Strax före deadline (1980) skildrade han sina upplevelser då de röda khmererna tog över Pnom Penh i Kambodja.
          </p><p>
            Sedan 1990 är han heltidsförfattare. Under åren 1992–2006 utgavs hans stora verk Historien om Sverige i elva delar. Den bokserien har tillsammans med de omkring trettio avsnitten av Hermans historia som sändes i SVT mellan 1991 och 2002 starkt bidragit till det ökade historieintresset i Sverige. Många har vittnat om att det är Herman Lindqvists medryckande sätt att berätta som har fått dem intresserade av historia.
          </p><p>
            Herman Lindqvist har en djup kunskap om Sveriges kungahus, som han har skrivit flera böcker om, senast Kungligt och mänskligt (2010). Han har också undervisat prinsessorna Victoria och Madeleine i Sveriges historia.
          </p><p>
            Hans serie om franska historiska personligheter började 2008 med Madame de Pompadour, ett porträtt av 1700-talsborgarflickan som blev kunglig älskarinna och fick en maktställning som få andra. Året därpå kom Jean Bernadotte, mannen vi valde, om den franske marskalken som blev vår förste kung av ätten Bernadotte, Karl XIV Johan, och våren 2011 kom Ludvig XIV, Solkungen.
          </p><p>
            Herman Lindqvists självbiografi om livet som journalist och författare, Mitt i allt, kom 2012. Året därpå skrev han en bok han länge velat skriva, om Sveriges och Finlands gemensamma historia: När Finland var Sverige. För den belönades han med 18 000 euro av Svenska Litteratursällskapet i Finland och med ett hedersdoktorat vid Åbo Akademi. Därefter har den flitige författaren också skrivit om Erik XIV och om Sverige som kolonialmakt, något som ingen tagit ett samlat grepp om tidigare.
          </p>
          <p>
            Varmt välkomna!
          </p>
        </>
      );
    },
    datum: "2026-08-04",
    img: "herman",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },
  {
    id: 18,
    namn: function () {
      return <>Författartisdag med <nobr>Nina van den Brink</nobr></>;
    },
    info: function () {
      return (
        <>
          <p>
            I år har vi den stora äran att kunna presentera en Augustprisvinnare på Krogbacken! Nina van den Brink fick Augustpriset 2022 för sin fackbok "Jag har torkat nog många golv" som handlar om författaren och städerskan Maja Eklöf.
          </p>
          <p>
            Nu kommer hon med sin första roman. Den heter Flickor och är en tät och drabbande berättelse om att vara flicka, om okuvlig vänskap och om att växa upp och tvingas hantera det man egentligen borde ha varit skyddad ifrån.
          </p>
          <p>
            "En stark debutroman som lockar till både skratt och gråt" skriver BTJ.
          </p>
          <p>
            Nina van den Brink är journalist, med bakgrund på bl.a. Dagens Industri, DI Weekend, Expressen och Fokus.
          </p>
          <p>
            Kom och hör Nina van den Brink berätta om boken på Krogbacken!
          </p>
          <p>
            Varmt välkomna!
          </p>
        </>
      );
    },
    datum: "2026-08-11",
    img: "nina-van-den-brink",
    pris: 0,
    tid: "14:00",
    konsertmeny: false,
    music: false,
    author: true,
  },



];

export default artistInfo;